import { SearchOutlined } from '@ant-design/icons';
import { Button, Checkbox, Drawer, Input, Space } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { categories } from '../../../constants';
import { setCategory } from '../../../redux/slices/filtersSlice';
import { store } from '../../../redux/store';

const Categories = ({ open, onClose, onApply, value, onChange }) => {
    // Use external state if provided, otherwise fall back to Redux
    const { category: reduxCategory } = useSelector((state) => state.filtersSlice);
    const isControlled = value !== undefined && onChange !== undefined;
    const externalCategories = isControlled ? value : reduxCategory;

    const [searchCategory, setSearchCategory] = useState('');
    // Local state for selections - only sync to parent on Apply
    const [selectedCategories, setSelectedCategories] = useState([]);

    // Initialize local state when drawer opens or external value changes
    useEffect(() => {
        if (open) {
            setSelectedCategories(externalCategories || []);
        }
    }, [open, externalCategories]);

    const handleChange = (newValue) => {
        // Update local state immediately for responsive UI
        setSelectedCategories(newValue);
    };

    const filteredCategories = useMemo(() => {
        const search = searchCategory.toLowerCase().trim();
        return search ? categories.filter((c) => c.toLowerCase().includes(search)) : categories;
    }, [searchCategory]);

    const handleApply = () => {
        // Only update parent state when Apply is clicked
        if (isControlled) {
            onChange(selectedCategories);
        } else {
            let updated = [...reduxCategory];
            updated = updated.filter((f) => !categories.includes(f)).concat(selectedCategories);
            store.dispatch(setCategory(updated));
        }
        // Pass selected categories to onApply so parent can use them immediately
        onApply?.(selectedCategories);
        onClose();
    };

    const handleClose = () => {
        // Reset local state to external value on cancel
        setSelectedCategories(externalCategories || []);
        onClose();
    };

    return (
        <Drawer
            title="Categories"
            open={open}
            onClose={handleClose}
            footer={
                <Button block type="primary" onClick={handleApply}>
                    Apply
                </Button>
            }
        >
            <Input
                size="large"
                placeholder="Search categories"
                prefix={<SearchOutlined />}
                value={searchCategory}
                onChange={(e) => setSearchCategory(e.target.value)}
                allowClear
                className="mb-2"
            />
            <Checkbox.Group
                value={selectedCategories?.filter((f) => categories.includes(f))}
                onChange={(value) => handleChange(value)}
            >
                <Space direction="vertical">
                    {filteredCategories?.map((category) => (
                        <Checkbox key={category} value={category}>
                            {category}
                        </Checkbox>
                    ))}
                </Space>
            </Checkbox.Group>
        </Drawer>
    );
};

export default Categories;
